import { render, staticRenderFns } from "./RolePermission.vue?vue&type=template&id=2f0fc248"
import script from "./RolePermission.vue?vue&type=script&lang=js"
export * from "./RolePermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports